import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import { mapActivityData } from 'utils/activities'
import {
  add,
  setLoadStatus,
  setLastLoadedTimestamp
} from '../redux/bookmarks'

export default function * fetchBookmarks (action) {
  const { lastLoadedTimestamp } = action.payload

  yield put(setLoadStatus({
    isLoading: true,
    isLoaded: false
  }))

  const args = {}
  if (lastLoadedTimestamp) {
    args.olderThanTimestamp = lastLoadedTimestamp
  }

  try {
    const { Bookmarks } = yield call(apiGetData, 'MyBookmarks', args)

    let bookmarks = []
    let newLastLoadedTimestamp = null

    Bookmarks.forEach(Bookmark => {
      const bookmark = {
        id: Bookmark.Activity.Id,
        timestamp: Bookmark.Timestamp,
        activity: mapActivityData(Bookmark.Activity)
      }

      bookmarks.push(bookmark)

      if (!lastLoadedTimestamp || bookmark.timestamp < lastLoadedTimestamp) {
        newLastLoadedTimestamp = bookmark.timestamp
      }
    })

    const batchedActions = [
      ...bookmarks.map(bookmark => add(bookmark)),
      setLoadStatus({
        isLoading: false,
        isLoaded: bookmarks.length < 20
      })
    ]

    if (newLastLoadedTimestamp !== null) {
      batchedActions.push(setLastLoadedTimestamp(newLastLoadedTimestamp))
    }

    yield put(batchedActions)
  } catch (error) {
    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))
  }
}
